import { render } from "./NotFound.vue?vue&type=template&id=eeca69d4"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=eeca69d4&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__